import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private msalService: MsalService,
              private router: Router) { }

  login() {
    this.router.navigate(['/login']);
  }

  logout() {
    this.msalService.logout();
  }

  isLoggedIn() {
    return !!this.msalService.getAccount();
  }

  isAdminAccount() {
    if (this.isLoggedIn() && this.msalService.getAccount().idToken.roles.indexOf(environment.roleAdmin) > -1){
      return true;
    }
    return false;
  }

  getUserName(){
    let name = '';
    if (this.isLoggedIn()) {
      name = this.msalService.getAccount().name;
    }
    return name;
  }

  getUserNameAccount(){
    let name = '';
    if (this.isLoggedIn()) {
      name = this.msalService.getAccount().userName;
    }
    return name;
  }
}
